import React from 'react';
import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ProductInfo } from '../compareData';
import { ReasonIcon } from '../CompareIcons';
import { ColumnBlock } from './ColumnBlock';
import styles from './ReasonsBlock.module.scss';

/** "Top reasons to buy" — an icon + one-line benefit per reason. */
export const ReasonsBlock: React.FC<{ product: ProductInfo }> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <ColumnBlock title={t('compare_v2_top_reasons')}>
      <Box className={styles.list}>
        {product.reasons.map((reason) => (
          <Box key={reason.labelKey} fw={500} className={styles.reason}>
            <Box className={styles.reasonIcon}>
              <ReasonIcon name={reason.icon} />
            </Box>
            {t(reason.labelKey)}
          </Box>
        ))}
      </Box>
    </ColumnBlock>
  );
};
